var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isDesktop)?_c('a',[_c('i',{staticClass:"icon-home3 home-icon"}),_c('span',{staticClass:"home-label"},[_vm._v("  "+_vm._s(_vm.$t('App#Logo#Title Home')))])]):(!_setup.isDesktop)?_c('a',[_c('i',{staticClass:"icon-home3 home-icon"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }